// extracted by mini-css-extract-plugin
export default {"animation":"CircleLoaderV2-module__animation","rotate":"CircleLoaderV2-module__rotate","dash":"CircleLoaderV2-module__dash"};